
// Initialize polyfill for external SVG sprites

svg4everybody();